import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const caseStudyCards = [
  {
    slug: "novotel-london-excel-laundry-partnership",
    hotelName: "Novotel London Excel",
    title: "Same-Day Guest & Staff Laundry Partnership",
    summary:
      "Xcel Dry Cleaners manages daily guest and staff laundry for Novotel London Excel, with morning collection and same-evening delivery — keeping the hotel running smoothly around ExCeL's busy events calendar.",
    tag: "Hotel Partnership",
  },
  {
    slug: "crowne-plaza-london-docklands-laundry-partnership",
    hotelName: "Crowne Plaza London Docklands by IHG",
    title: "Same-Day Guest & Staff Laundry Partnership",
    summary:
      "A high-volume IHG property needed a laundry partner that could match its pace. Xcel provides same-day collection and delivery for both guest dry cleaning and staff uniforms — with 100% positive feedback maintained to date.",
    tag: "Hotel Partnership",
  },
  {
    slug: "ibis-london-excel-docklands-laundry-partnership",
    hotelName: "ibis London Excel Docklands",
    title: "Same-Day Guest & Staff Laundry Partnership",
    summary:
      "ibis needed a cost-effective, reliable laundry solution without the overhead of in-house operations. Xcel's same-day service keeps guest laundry and staff uniforms consistently ready — without any extra on-site equipment.",
    tag: "Hotel Partnership",
  },
];

function CaseStudiesListPage() {
  useEffect(() => {
    const defaultTitle = "Hotel Laundry Case Studies | Xcel Dry Cleaners London";
    const defaultDesc =
      "Read how Xcel Dry Cleaners provides same-day laundry partnerships for Novotel, Crowne Plaza and ibis hotels near ExCeL London.";
    document.title = defaultTitle;
    document.getElementById("title")?.setAttribute("content", defaultTitle);
    document.getElementById("description")?.setAttribute("content", defaultDesc);

    const base_url = process.env.REACT_APP_BACKEND_URL;
    if (base_url) {
      axios({
        method: "post",
        url: `${base_url}/api/get_meta_tags`,
        data: { url: window.location.pathname.length > 1 ? window.location.pathname.replace(/\/+$/, "") : window.location.pathname },
        headers: { Accept: "application/json", "Access-Control-Allow-Methods": "GET, POST" },
      })
        .then((response: any) => {
          if (
            response &&
            response.data &&
            response.data.Response &&
            response.data.Response.response_code !== "-1" &&
            response.data.data
          ) {
            const metaTitle = response.data.data.meta_title || defaultTitle;
            const metaDescription = response.data.data.meta_description || defaultDesc;
            document.title = metaTitle;
            document.getElementById("title")?.setAttribute("content", metaTitle);
            document.getElementById("description")?.setAttribute("content", metaDescription);
          }
        })
        .catch(() => {});
    }
  }, []);

  return (
    <>
      <div className="xcel-page-hero">
        <div className="container">
          <nav className="xcel-breadcrumb" aria-label="breadcrumb">
            <a href="/">Home</a>
            <span aria-hidden="true"> / </span>
            <span aria-current="page">Case Studies</span>
          </nav>
          <h1>Hotel Laundry Case Studies</h1>
          <p className="xcel-page-hero-meta">
            How Xcel Dry Cleaners partners with hotels near ExCeL London
          </p>
        </div>
      </div>

      <div className="xcel-cs-list-page">
        <div className="container">
          <p className="xcel-cs-list-intro">
            Xcel Dry Cleaners operates same-day laundry partnerships with hotels
            across the ExCeL London area. Below are three partnerships where we
            collect each morning, clean and press during the day, and return
            everything that same evening.
          </p>

          <div className="xcel-cs-list-grid">
            {caseStudyCards.map((card) => (
              <Link
                key={card.slug}
                to={`/case-studies/${card.slug}`}
                className="xcel-cs-card"
              >
                <span className="xcel-cs-card-tag">{card.tag}</span>
                <h2 className="xcel-cs-card-hotel">{card.hotelName}</h2>
                <h3 className="xcel-cs-card-title">{card.title}</h3>
                <p className="xcel-cs-card-summary">{card.summary}</p>
                <span className="xcel-cs-card-read-more">
                  Read case study →
                </span>
              </Link>
            ))}
          </div>

          <div className="xcel-cta-banner" style={{ marginTop: "56px" }}>
            <h3>
              Looking for a reliable hotel laundry partner in London? Contact
              Xcel Dry Cleaners to discuss a same-day schedule for your
              property.
            </h3>
            <Link to="/Contactus" className="xcel-cta-btn">
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      <div className="xcel-blog-links-strip">
        <div className="container text-center">
          <p className="mb-2">
            <strong>Learn more about hotel laundry outsourcing</strong>
          </p>
          <div className="xcel-blog-strip-links">
            <Link to="/blog/hotel-laundry-outsourcing-london">
              Why Hotels Are Outsourcing Laundry
            </Link>
            <Link to="/blog/commercial-cleaning-services-london">
              Commercial Laundry for Businesses
            </Link>
            <Link to="/blog/professional-garment-care-guide">
              Professional Garment Care Guide
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default CaseStudiesListPage;
